import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { BFF_URL} from "../environments/environment";
import { take } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class TopupService {
    private http = inject(HttpClient);

    refillMdn(mdn: string, pinlessToken, amount): Promise<any> {
        const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});

		return new Promise<any>((resolve, reject) => {
			this.http.post<any>(`${BFF_URL}/v1/ca/account/${mdn}/refill`, {refillType: "PINLESS", pinlessToken, amount}, { headers })
				.pipe(take(1))
				.subscribe({
					next: (result) => resolve(result),
					error: (error) => reject(error)
				});
		});
	}
    redeemVoucher(mdn: string, code): Promise<any> {
        const headers = new HttpHeaders({
			'Content-Type': 'application/json'
		});

		return new Promise<any>((resolve, reject) => {
			this.http.post<any>(`${BFF_URL}/v1/ca/account/${mdn}/refill`, {refillType: "VOUCHER", voucher: code}, { headers })
				.pipe(take(1))
				.subscribe({
					next: (result) => resolve(result),
					error: (error) => reject(error)
				});
		});
	}
}